import React, { Component } from "react";
import { List, Image } from "semantic-ui-react";
import crisisLogo from "../../assets/crisis-logo.png";
import SimulationTitle from "./SimulationTitle";
import HelpHoverComponent from "../helpers/HelpHoverComponent";
import moment from "moment";
import { getLanguagePrefix } from "../utilities/LanguageUtilities";

class CrisisDetailComponent extends Component {
  formatDate = (date, language) => {
    return moment(date)
      .locale(getLanguagePrefix(language))
      .format(`MMMM D, YYYY [${this.props.translate("at")}] hh:mm A`);
  };

  render() {
    const translate = this.props.translate;
    const simulationDetails = this.props.simulationDetails;
    const loadingDetails = this.props.loadingDetails;
    const language = this.props.language;
    let detailBoxStyles = "detailsDataLoading";
    let listDetails = [];
    if (!loadingDetails && simulationDetails) {
      detailBoxStyles = "detailsDataCharged";

      let startDateText = null;
      let endDateText = null;
      if (simulationDetails.professorManagedProgress) {
        startDateText = translate("MedicaDetailScreen:professorManaged");
        endDateText = translate("MedicaDetailScreen:professorManaged");
      } else {
        startDateText = this.formatDate(simulationDetails.startTime, language);
        endDateText = this.formatDate(simulationDetails.endTime, language);
      }

      listDetails = [
        {
          item: translate("Common:status"),
          content: translate(`Common:${simulationDetails.status}`),
        },
        {
          item: translate("Common:currentDay"),
          content: simulationDetails.currentSimulationDay,
        },
        { key: 3, item: translate("Common:startDate"), content: startDateText },
        { key: 4, item: translate("Common:endDate"), content: endDateText },
      ];
    } else {
      listDetails = [{ key: 1, item: translate("Common:status"), content: "" }];
    }
    return (
      <div>
        <SimulationTitle title={simulationDetails && !loadingDetails ? simulationDetails.name : ""} />
        <div className="detailsContainer">
          <div className="crisisSimulationIcon">
            <Image className="crisisDetailLogo" src={crisisLogo} size="small" />
          </div>
          <div className={`detailsData ${detailBoxStyles}`}>
            <p>{translate("simulationDetails").toUpperCase()}</p>
            <List>
              {listDetails.map((detail, index) => {
                if (!detail.content) return null;
                let helpHoverComponent = null;
                if (detail.hasHelp) {
                  helpHoverComponent = <HelpHoverComponent helpMessage={translate(detail.helpMessage)} />;
                }
                return (
                  <List.Item key={index}>
                    {loadingDetails === true ? (
                      <div className="animated-background" />
                    ) : (
                      <div>
                        <strong>{detail.item}: </strong>
                        {detail.content}
                        {helpHoverComponent}
                      </div>
                    )}
                  </List.Item>
                );
              })}
            </List>
          </div>
        </div>
      </div>
    );
  }
}

export default CrisisDetailComponent;
